import { render } from "./DesktopMenuBar.vue?vue&type=template&id=94e678ae&scoped=true"
import script from "./DesktopMenuBar.vue?vue&type=script&lang=js"
export * from "./DesktopMenuBar.vue?vue&type=script&lang=js"

import "./DesktopMenuBar.vue?vue&type=style&index=0&id=94e678ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94e678ae"]])

export default __exports__